<template>
  <div id="app">
    <yetkidialog ref="yetkidialog"></yetkidialog>
    <snackbarcomp v-bind:mesaj="text1" ref="showMessage" v-model="snackbar"></snackbarcomp>

    <v-card color="grey lighten-5" flat>
      <v-layout row wrap>
        <v-flex xs12 sm12>
          <v-toolbar size="120px" dark color="info">
            <v-toolbar-title class="baslikfont"> {{ $t('Current-Movements') }} </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-text-field flat="" solo-inverted="" hide-details v-model="search" :label="$t('Search')" append-icon="search">
            </v-text-field>


            <v-tooltip bottom>
              <v-btn :disabled="!sayfayetki.Save" slot="activator" @click="carihareketEkle()" flat> <span
                  class="hidden-sm-and-down"> {{ $t('Add') }}
                </span>
                <v-icon right dark>add_box</v-icon>
              </v-btn>
              <span v-if="!sayfayetki.Save">{{ $t('Limited-Authorization') }}</span>
              <span v-if="sayfayetki.Save">{{ $t('Add') }}</span>
            </v-tooltip>


          </v-toolbar>
        </v-flex>
        <v-container fluid>

          <v-layout row wrap>
            <v-flex xs12 sm4 md2>


              <tarihim :etiket="$t('Starting-Date')" :detaygizle="false" v-model="date" v-bind:defaultvalue="'ok'"
                :rules="[v => !!v || $t('Please-select-a-date')]"></tarihim>

            </v-flex>
            <v-flex xs12 sm4 md2>
              <tarihim :etiket="$t('Finishing-Date')" :detaygizle="false" v-model="date2" v-bind:defaultvalue="'ok'"
                :rules="[v => !!v || $t('Please-select-a-date')]"></tarihim>
            </v-flex>




            <v-flex>

              <v-layout>
                <div v-if="load1">
                  <v-btn color="info" @click="CarihareketGetir()" fab small="" dark>
                    <v-icon>search</v-icon>
                  </v-btn>
                </div>

                <v-badge color="white" :overlap="true">
                  <template v-slot:badge>
                    <v-icon v-if="filtrevarmi" large color="green">
                      check_circle_outline </v-icon>
                  </template>

                  <v-btn small="" @mouseenter="tooltip = true" @mouseleave="tooltip = false" ref="fab"
                    @click.native="dialogfiltre=true" color="info" fab dark>
                    <v-icon>filter_list</v-icon>
                  </v-btn>
                  <v-tooltip bottom="" :activator="el" v-model="tooltip">
                    <span>{{$t('Add-Search-Filter')}}</span>
                  </v-tooltip>

                </v-badge>

              </v-layout>
            </v-flex>

            <v-flex xs12 sm12>
              <v-card-title>
                <v-spacer></v-spacer>

              </v-card-title>
              <v-data-table :headers="headers" :loading="progress" :rows-per-page-items=[50,100] :items="items"
                :search="search">
                <v-progress-linear slot="progress" indeterminate></v-progress-linear>
<template slot="items" slot-scope="props">
  <tr @click="git(props.item)" item>
    <td class="text-xs-left">{{ props.item.Cari.Kod }}</td>
    <td class="text-xs-left">{{ props.item.Cari.Unvan }}</td>
    <td class="text-xs-left">{{ props.item.Tarih | dateformat }}</td>
    <td class="text-xs-left">{{ props.item.Evrak.Evrakkod }}</td>
    <td class="text-xs-left">{{ props.item.Evrakno }}</td>
    <td class="text-xs-left">{{ props.item.Aciklama }}</td>
    <td class="text-xs-left">{{ props.item.BA }}</td>
    <td class="text-xs-right">{{ props.item.Tutar | moneyformat }}</td>
    <td class="text-xs-left">{{ props.item.Faturano }}</td>
    <td class="text-xs-left">{{ props.item.Referans.Kod }}</td>
    <td class="text-xs-left">
       <v-tooltip bottom>
              <v-btn  slot="activator" @click.stop="openChangeLog(props.item)" flat> <span
                  class="hidden-sm-and-down"> 
                </span>
                <v-icon >info</v-icon>
              </v-btn>
              
              <span >{{ $t('Log-Records') }}</span>
            </v-tooltip>


           
      
    </td>
  </tr>

                </template>
                <v-alert slot="no-results" :value="true" color="error" icon="warning">
                   {{ $t('No-records-searched-for', { value: search}) }}
                </v-alert>
              </v-data-table>
            </v-flex>
        

            <v-dialog v-model="dialog" persistent max-width="290">
              <v-card>
                <v-card-title class="headline">{{ $t('Warning') }} !</v-card-title>
                <v-card-text>{{dialogmessage}}</v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="green darken-1" flat @click.native="karsicariac()">{{ $t('OK') }}</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>


            <v-dialog v-model="dialogfiltre" scrollable="" persistent="" max-width="400px">
              <v-card color="grey lighten-5">

                <v-card-title>{{ $t('Filter-selection') }}</v-card-title>
                <v-divider></v-divider>
                <v-card-text>
                  <v-flex mt-2 xs12 sm12 md12>
                    <v-card flat class="white--text">
                      <v-card-actions>
                        <v-layout row="" wrap="">
                          <div class="flex md12">
                           <cariaracomp v-bind:etiket="$t('Current-Account')" v-bind:value="CariHareketInput.CariKodu" 
                           v-model="CariHareketInput.CariKodu"></cariaracomp>
                            <v-flex xs12 sm12 md12>
                              <referansmerkezicomp :coper="false" :detaygizle="'true'" v-model="CariHareketInput.Filtreler.Referans">
                              </referansmerkezicomp>
                            </v-flex>
                            <v-flex xs12 sm12 md12>
                              <masrafmerkezicomp :detaygizle="'true'" v-model="CariHareketInput.Filtreler.Masraf">
                              </masrafmerkezicomp>
                            </v-flex>
                            <v-layout>
                              <v-flex xs12 sm6 md6>
                                <parainput :simge="getparabirimi()" v-model="CariHareketInput.Filtreler.BaslangicTutar"
                                  :etiket="$t('Amount-Commencement')" :autocomplete="'autocomplete'"></parainput>
                              </v-flex>
                              <v-flex xs12 sm6 md6>
                                <parainput :simge="getparabirimi()" :detaygizle="'true'"
                                  v-model="CariHareketInput.Filtreler.BitisTutar" :etiket="$t('Amount-Completion')"
                                  :autocomplete="'autocomplete'"></parainput>
                              </v-flex>
                            </v-layout>
                            <v-autocomplete hide-details :items="evraktipi"
                              v-model="CariHareketInput.Filtreler.EvrakTipi" :label="$t('Document-Type')" item-text="Title"
                              item-value="Evrakkod">

                            </v-autocomplete>


                            <v-text-field hide-details="" v-model="CariHareketInput.Filtreler.EvrakNo" aria-multiline=""
                              :label="$t('Document-No')"></v-text-field>
                            <v-text-field hide-details="" v-model="CariHareketInput.Filtreler.FaturaNo"
                              aria-multiline="" :label="$t('Invoice-No')"></v-text-field>
                            <v-checkbox hide-details v-model="CariHareketInput.BiletHaric"
                              :label="$t('Excluding-Ticket-Actions')"></v-checkbox>


                          </div>
                        </v-layout>
                      </v-card-actions>
                    </v-card>
                  </v-flex>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="blue darken-1" flat @click="filtreiptal()">{{$t("cancel_button")}}</v-btn>
                  <v-btn color="blue darken-1" flat @click="filtrekayit()">{{ $t('Apply-Filters') }}</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>

<v-dialog v-model="logDialog" max-width="900px">
  <v-card>
    <v-card-title class="headline">Değişiklik Logları</v-card-title>

    <v-card-subtitle class="mt-2">
      <strong>İlk Kayıt:</strong> {{ changeLogs.IlkKayitTarihi | dateformat }} - {{ changeLogs.IlkKaydeden }}
     <!-- GÜNCEL DEĞERLER KARTI -->
<v-card class="ma-4 pa-4 log-row" outlined>

  <div class="d-flex justify-space-between align-center mb-2">
    <div>
      <strong># Güncel Kayıt</strong>
    </div>
  </div>

  <v-simple-table dense>
    <thead>
      <tr>
        <th>Alan</th>
        <th>Güncel Değer</th>
      </tr>
    </thead>
    <tbody>
      <tr
        v-for="(etiket, key) in alanMap"
        :key="'guncel-' + key"
      >
<td class="guncel-alan">{{ etiket }}</td>
<td>{{ changeLogs.GuncelKayit && changeLogs.GuncelKayit[key] ? changeLogs.GuncelKayit[key] : '-' }}</td>
      </tr>
    </tbody>
  </v-simple-table>
</v-card>



    </v-card-subtitle>

    <v-card-text>
      <v-container>
        <v-row v-for="(log, index) in changeLogs.Degisiklikler" :key="index" class="mb-4">
          <v-col cols="12">
            <v-card outlined>
              <v-card-title class="d-flex justify-space-between">
                <div>
                  <strong>#{{ index + 1 }} - Değişiklik</strong>
                </div>
                <div>
                  <v-chip small color="info" text-color="white">
                    {{ log.Kullanici || 'Bilinmiyor' }}
                  </v-chip>
                  <span class="grey--text ml-2">{{ log.Tarih | dateformat }}</span>
                </div>
              </v-card-title>

              <v-card-text>
               <v-simple-table dense class="log-table">
  <thead>
    <tr>
      <th style="width: 30%">Alan</th>
      <th style="width: 30%">Eski Değer</th>
      <th style="width: 30%">Yeni Değer</th>
    </tr>
  </thead>
  <tbody>
    <tr v-for="(d, i) in log.Degisiklikler" :key="i" class="log-row">
      <td><strong>{{ d.AlanAdi }}</strong></td>
      <td>{{ d.EskiDeger || '-' }}</td>
      <td>{{ d.YeniDeger || '-' }}</td>
    </tr>
  </tbody>
</v-simple-table>

              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-card-text>

    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="primary" text @click="logDialog = false">Kapat</v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>








          </v-layout>
        </v-container>

        <v-container fluid>
          <v-layout row wrap>

          </v-layout>
        </v-container>
      </v-layout>
    </v-card>
  </div>
</template>

<script>
  import auth from '../../../api/auth'
  import parainput from '../customcomp/parainput'
  import dovizinput from '../customcomp/dovizinput'
  import yuzdeinput from '../customcomp/yuzdeinput'
  import tarihim from '../customcomp/tarihim'
  import referansmerkezicomp from "@/components/app/bilet/partpage/referanscomp.vue"
  import masrafmerkezicomp from "@/components/app/bilet/partpage/masrafmerkezicomp.vue"
  import helpers from "@/components/app/customcomp/helpers.js"
  import yetkidialog from "@/components/app/customcomp/yetkidialog.vue"
  import cariaracomp from '@/components/app/customcomp/cariaracomp.vue'
  import snackbarcomp from "@/components/app/customcomp/snackbarcomp";


  export default {
    data() {
      return {
        alanMap: {
      SirketKodu: "Şirket",
      Tarih: "Tarih",
      Vade: "Vade Tarihi",
      EvrakTipi: "Evrak Tipi",
      Evrakno: "Evrak No",
      Tutar: "Tutar",
      Aciklama: "Açıklama",
      DovizCinsi: "Döviz Tipi",
      Kur: "Döviz Kur Tutar",
      DovizTutar: "Döviz Tutar",
      Brut: "Brüt",
      Kdv: "KDV",
      KdvOran: "KDV Oranı",
      MuhEnt: "Muhasebeye Entegre Et"
    },
        logDialog: false,
changeLogs: [],
        sayfayetki: {
          Screen: false,
          Update: false,
          Save: false,
          Delete: false,
          Status: false,
          Message: null,
          islem: 0,
        },
        filtrevarmi: false,
        search: '',
        headers: [{
            text: this.$t('Account'),
            value: 'Cari.Kod'
          },
          {
            text: this.$t('Title_label'),
            value: 'Cari.Unvan',
          },
          {
            text: this.$t('Date'),
            value: 'Tarih',

          },
          {
            text: this.$t('Document-Type'),
            value: 'Evrak.Evrakkod'
          },
          {
            text: this.$t('Document-No'),
            value: 'Evrakno'
          },
          {
            text: this.$t('Description'),
            value: 'Aciklama'
          },
          {
            text: 'B/A',
            value: 'BA'
          },
          {
            text: this.$t('Amount'),
            value: 'Tutar',
            align: 'right'
          },
          {
            text: this.$t('Invoice-No'),
            value: 'Faturano'
          },
          {
            text: this.$t('Reference'),
            value: 'Referans.Kod'
          },
          {
  text: 'Log',
  value: 'log',
  sortable: false
}
        ],
        date: null,
        islemdurumu: null,
        menu: false,
        modal: false,
        dateFormatted: '',
        date2: null,
        menu2: false,
        dateFormatted2: '',
        modal2: false,
        harekettipi: '',
        items: [],

        CariHareketInput: {
          SirketKodu: null,
          BaslangicTarihi: null,
          BiletHaric: false,
          BitisTarihi: null,
          CariKodu: null,
          Filtreler: {
            Referans: null,
            Masraf: null,
            BaslangicTutar: 0,
            BitisTutar: 0,
            EvrakNo: null,
            EvrakTipi: null,
            FaturaNo: null,
          },
          Entegre: false,
          ListTipi: 0, // 0 : Hepsi, 1 : Bilet Kayıtları Hariç
        },


        CariHareket: {
          Account: '',
          movementCounter: '',
          Title: '',
          Date: '',
          DocumentType: '',
          DocumentNumber: '',
          Explanation: '',
          Ba: '',
          Amount: '',
          InvoiceNumber: '',
          Reference: '',
          Id: '',
          OrderNumber: '',
          CompanyCode: ''
        },
        Movement: {
          Current: '',
          Nereden: '',
          SirketKodu: '',
          Tarih: null,
          DefID: ''
        },
        tooltip: false,
        el: null,
        StartDate: null,
        EndDate: null,
        load: false,
        load1: true,
        dialogmessage: '',
        dialog: false,
        progress: false,
        snackbar: false,
        y: 'top',
        x: 'right',
        mode: '',
        timeout: 6000,
        text1: '',
        statecari: [],
        loading: false,
        searchcari: null,
        dialogfiltre: false,
        evraktipi: [],
        dictionary: {
          custom: {

            tarihsecbas: {
              required: () => this.$t('Please-select-a-date')
            },
            tarihsecbit: {
              required: () => this.$t('Please-select-a-date')
            },
          }
        },
      }
    },
    beforeRouteEnter(to, from, next) {
      next(vm => {
        vm.prevRoute = from.path
      })
    },
    watch: {
    },
    filters: {

      dateformat: function (t) {
        return helpers.dateformat(t);
      },
      moneyformat: function (m) {
        return helpers.moneyformat(m);
      },

      bakiyekontrol: function (m) {
        return helpers.bakiyekontrol(m);
      }

    },
    methods: {
      openChangeLog(item) {
  const credentials = JSON.parse(localStorage.getItem('credentials'));

  const params = {
    CompanyCode: credentials.SirketKodu,
    Current: item.Cari.Kod,
    MovementDate: item.Tarih,
    EvrakNo: item.Evrakno
  };

  this.$http.post(auth.API_URL + 'api/CurrentMovement/GetChangeLog', params, {
    headers: {
      Authorization: 'Bearer ' + auth.getAuthHeader()
    }
  }).then((res) => {
    const logData = res.body;

    // SON GRUBU BUL
    let lastGroup = null;
if (logData && logData.Degisiklikler && logData.Degisiklikler.length > 0) {
  lastGroup = logData.Degisiklikler[logData.Degisiklikler.length - 1];
}

    if (lastGroup) {
      const cariParams = {
        CompanyCode: credentials.SirketKodu,
        Date: item.Tarih,
        AccountCode: item.Cari.Kod,
        OrderNumber: item.Sirano
      };

      // Cari hareket kaydını getir
      this.$http.post(auth.API_URL + 'api/CurrentMovement/Get', cariParams, {
        headers: {
          Authorization: 'Bearer ' + auth.getAuthHeader()
        }
      }).then((resCari) => {
        const cariVeri = resCari.body;

        // YeniDeğer boş olanları cari veriden doldur
        lastGroup.Degisiklikler.forEach(d => {
          if (!d.YeniDeger || d.YeniDeger === '') {
            // Örnek: Tutar için cariVeri.Tutar
            const alanAdi = d.AlanAdi;
            if (cariVeri.hasOwnProperty(alanAdi)) {
              d.YeniDeger = cariVeri[alanAdi];
            }
          }
        });

        // Güncel log state'ine ata
        this.changeLogs = logData;
this.changeLogs.GuncelKayit = resCari.body;

        this.logDialog = true;

      }).catch(() => {
        this.text1 = 'Güncel değer alınamadı.';
        this.snackbar = true;
      });

    } else {
      this.changeLogs = logData;
      this.logDialog = true;
    }

  }).catch(() => {
    this.text1 = 'Log kayıtları alınamadı.';
    this.snackbar = true;
  });
},


      getparabirimi() {
        return helpers.getparabirimi()
      },
      filtrekayit() {
        this.filtrevarmi = true;
        this.dialogfiltre = false;
        this.CarihareketGetir();
      },
      filtreiptal() {
        this.filtrevarmi = false;
        this.dialogfiltre = false;
        this.CariHareketInput.BiletHaric = false
        this.CariHareketInput.CariKodu = null
        this.CariHareketInput.Filtreler.Referans = null
        this.CariHareketInput.Filtreler.Masraf = null
        this.CariHareketInput.Filtreler.BaslangicTutar = 0
        this.CariHareketInput.Filtreler.BitisTutar = 0
        this.CariHareketInput.Filtreler.EvrakNo = null
        this.CariHareketInput.Filtreler.EvrakTipi = null
        this.CariHareketInput.Filtreler.FaturaNo = null
        this.CariHareketInput.Entegre = false
        this.CariHareketInput.ListTipi = 0 // 0 : Hepsi, 1 : Bilet Kayıtları Hariç
        this.CarihareketGetir();
      },
      carihareketEkle() {
        var credentials = JSON.parse(window.localStorage.getItem('credentials'));
        var params = {
          MusteriID: credentials.MusteriID,
          HareketTip: 'Cari',
          HareketSayisi: 1
        }

        this.$http.post(auth.API_URL + 'api/Register/PackageCustomerInfos', params, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {

          if (response.body.UyelikStatus == true) {

            if (response.body.KontorStatus == true) {

              var url = '#/carihareketler/yeni/'
              window.open(url, '_self')


            } else {
              this.text1 = this.$t('not-process-need-purchase-continue-process')
              this.snackbar = true
            }

          } else {
            this.text1 = this.$t('membership-expired-need-renew-membership-process')
            this.snackbar = true
          }


        }, (response) => {

          if (response.status === 0) {
            this.text1 = 'Service Unavailable-ProductCustomerInfo'
            this.snackbar = true
            islemok = false
          } else {
            this.text1 = 'Service Unavailable-ProductCustomerInfo'
            this.snackbar = true
          }
        })

      },
      CarihareketGetir: CarihareketGetir,
      getDateNow: getDateNow,
      karsicariac: karsicariac,
      git: git
    },
    beforeMount: beforeMount,
    components: {
      'parainput': parainput,
      'dovizinput': dovizinput,
      'yuzdeinput': yuzdeinput,
      tarihim,
      referansmerkezicomp,
      masrafmerkezicomp,
      yetkidialog,
      cariaracomp,
      snackbarcomp
    },
    mounted() {
      this.$validator.localize('en', this.dictionary)
      this.el = this.$refs.fab.$el

      this.sayfayetki = helpers.pageScreenAuth(this.$route.name)

      if (this.sayfayetki.Status == true) {

        var credentials = JSON.parse(window.localStorage.getItem('credentials'));

        this.progress = true
        this.load = true
        this.load1 = false
        this.date = getDateNow()
        this.date2 = getDateNow()
        this.CariHareketInput.BaslangicTarihi = this.date
        this.CariHareketInput.BitisTarihi = this.date2
        this.CariHareketInput.SirketKodu = credentials.SirketKodu


        var Params = this.CariHareketInput
        this.$http.post(auth.API_URL + 'api/movement/index', Params, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {
          this.items = response.body
          this.progress = false
          this.load = false
          this.load1 = true
          this.error = false
        }, (response) => {
          if (response.status === 0) {
            this.load1 = true
            this.progress = false

            this.error = false
            this.error = 'Service Unavailable'
          } else {
            this.error = response.statusText
            this.load1 = true
            this.progress = false

            this.error = false
          }
        })

        var params1 = {
          CompanyCode: credentials.SirketKodu,

        }
        this.$http.post(auth.API_URL + 'api/doctype/List', params1, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {
          this.evraktipi = response.body

        }, (response) => {
          if (response.status === 0) {

          } else {

          }
        })




      } else {

        this.$refs.yetkidialog.open(this.sayfayetki.Message, this.sayfayetki.islem).then(sonuc => {

          if (sonuc == true) {

            if (this.prevRoute != null) {
              let url = '#' + this.prevRoute

              window.open(url, '_self')
            } else {
              let url = '#/'
              window.open(url, '_self')
            }
          } 

        });

      }

    },


  }

  function karsicariac() {

    if (this.islemdurumu == 2) {
      var url1 = '#/carihareketler/duzenle/id?' + 'ac=' + this.CariHareket.Account + '&dt=' + this.CariHareket.Date +
        '&on=' + this.CariHareket.OrderNumber
      window.open(url1, '_target')
      this.dialog = false
    } else {
      this.dialog = false
    }


  }


  function git(v) {

    var credentials = JSON.parse(window.localStorage.getItem('credentials'));
      var GetMovement = {
      CompanyCode: credentials.SirketKodu,
      Date: v.Tarih,
      AccountCode: v.Cari.Kod,
      OrderNumber: v.Sirano
      }

      if(v.Tarih == null || v.Tarih == ""){
         let data ={
          response: {},
          request: GetMovement,
          api:'CurrentMovement/Get',
          type:1,
          message: this.$t('The-date-field-cannot-be-empty-Please-add-date')
        };
        this.$refs.showMessage.open(data);
        return false;
      }


  
    this.$http.post(auth.API_URL + 'api/CurrentMovement/Get', GetMovement, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {

      this.Movement.Nereden = response.body.Nereden
      this.Movement.SirketKodu = response.body.SirketKodu
      this.Movement.DefID = response.body.TanimID
      this.Movement.Date = response.body.Tarih

      var params = {
        Whereis: response.body.Nereden,
        CompanyCode: response.body.SirketKodu,
        DefID: response.body.TanimID,
        Date: response.body.Tarih
      }

      this.$http.post(auth.API_URL + 'api/CurrentMovement/ShowContr', params, {
        headers: {
          'Authorization': 'Bearer ' + auth.getAuthHeader()
        }
      }).then((response) => {
        
           
        if (response.body.Status === true) {
          var closeCariIDS = JSON.parse(localStorage.getItem('closeCariIDS'));
          //cari hareketlerdeki sira no kontrolu icin kontroller
          if(typeof closeCariIDS !== 'undefined' && closeCariIDS != null){
                  

            var isCariClosed = closeCariIDS.find((x)=> x == v.Sirano);  
            if(typeof isCariClosed == 'undefined'){

            this.islemdurumu = 0
            let url = '#/carihareketler/duzenle/id?' + 'ac=' + v.Cari.Kod + '&dt=' + v.Tarih + '&on=' + v.Sirano
            window.open(url, '_blank')
            }else{
              this.CarihareketGetir();
            }
          } else{
               

            this.islemdurumu = 0
            let url = '#/carihareketler/duzenle/id?' + 'ac=' + v.Cari.Kod + '&dt=' + v.Tarih + '&on=' + v.Sirano
            window.open(url, '_blank')
          }
  

        } else {

          if (response.body.StatusType == 1) {

            this.islemdurumu = 1

            this.dialog = true
            this.dialogmessage = this.$t(response.body.ResponseMessage)

          } else if (response.body.StatusType == 2) {

            this.islemdurumu = 2


            this.dialog = true
            this.dialogmessage = this.$t(response.body.ResponseMessage)

            this.CariHareket.Account = response.body.CariLoad.Cari.Kod
            this.CariHareket.Date = response.body.CariLoad.Tarih
            this.CariHareket.OrderNumber = response.body.CariLoad.Sirano
            this.CariHareket.CompanyCode = response.body.CariLoad.SirketKodu


          }
        }
      })
    }, (response) => {
      if (response.status === 0) {
        this.text1 = 'Service Unavailable'
        this.snackbar = true
      } else {
        this.text1 = 'Service Unavailable'
        this.snackbar = true
      }
    })

  }

  function beforeMount() {

  }



  function getDateNow() {
    var today = new Date();
    var dd = today.getDate();
    var mm = today.getMonth() + 1; //January is 0!
    var yyyy = today.getFullYear();

    if (dd < 10) {
      dd = '0' + dd
    }

    if (mm < 10) {
      mm = '0' + mm
    }
    today = yyyy + '-' + mm + '-' + dd
    return today
  }

  function CarihareketGetir() {
    this.dialogfiltre = false;

console.log(this.sayfayetki);
    this.$validator.validateAll().then((result) => {

      if (result) {

        var bastarih = new Date(this.date)
        var bittarih = new Date(this.date2)

        if (bastarih <= bittarih) {


          var credentials = JSON.parse(window.localStorage.getItem('credentials'));

          this.progress = true


          if (this.date == null) {
            this.date = getDateNow()
          }

          if (this.date2 == null) {
            this.date2 = getDateNow()
          }

          this.CariHareketInput.BaslangicTarihi = this.date
          this.CariHareketInput.BitisTarihi = this.date2
          this.CariHareketInput.SirketKodu = credentials.SirketKodu


          this.load1 = false
          this.load = true
          var Params = this.CariHareketInput

          this.$http.post(auth.API_URL + 'api/movement/index', Params, {
            headers: {
              'Authorization': 'Bearer ' + auth.getAuthHeader()
            }
          }).then((response) => {
            this.items = response.body
            this.progress = false
            this.load1 = true
            this.load = false
             var closeCariIDS = JSON.parse(localStorage.getItem('closeCariIDS'));
            if(typeof closeCariIDS !== 'undefined' && closeCariIDS != null){
                localStorage.removeItem('closeCariIDS');
            }

          }, (response) => {
            if (response.status === 0) {
              this.error = 'Service Unavailable'
              this.load1 = true
              this.progress = false
              this.error = false
            } else {
              this.error = response.statusText
              this.load1 = true
              this.progress = false
              this.error = false

            }
          })
        } else {
          this.text1 = this.$t('start-date-cannot-greater-than-end-date')
          this.snackbar = true
        }
      }
    })
  }
</script>

<style scoped>
.log-table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0 12px; /* satırlar arası boşluk */
}

.log-row {
  background: #fafafa;
  border-radius: 6px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
  transition: background 0.2s;
}

.log-row:hover {
  background: #f0f8ff;
}

td {
  padding: 6px 12px !important;
  font-size: 14px;
}

th {
  padding: 6px 12px !important;
  font-size: 14px;
  font-weight: bold;
}
.guncel-alan {
  font-weight: bold;
}
</style>
